import { render } from "./News39.vue?vue&type=template&id=034d5670"
import script from "./News39.vue?vue&type=script&lang=js"
export * from "./News39.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__